<template>
  <div class="section center" id="n2Section">
    <div class="l-700 text-orange" data-aos="fade-down">
      Cartas de amor e despedida
    </div>
    <br />
    <br />
    <video
      autoplay
      loop
      class="img-moro"
      src="@/assets/images/cartas-de-amor.mp4"
    ></video>
    <p class="mt-5 text text-justify" data-aos="fade-down">
      / / /
      <br />
      <br />
      <button
        v-if="audioCarta3Playing"
        class="button-audio"
        @click="audioCarta3Stop()"
      >
        <i class="bi bi-stop-circle"></i> Ouça a carta
      </button>
      <button v-else class="button-audio" @click="audioCarta3Play()">
        <i class="bi bi-play-circle"></i> Ouça a carta
      </button>

      “Minha vida, eu não sei mais o que fazer. Estou há 20 dias com febre. Ela
      vai e volta. De vez em quando, dor de cabeça e tosse seca. Não sinto gosto
      de nada. E nem cheiro de nada. Estou apavorado. Não sou só eu. Tem vários
      com esses sintomas, vida.”
      <br />
      <br />
      <button
        v-if="audioCarta1Playing"
        class="button-audio"
        @click="audioCarta1Stop()"
      >
        <i class="bi bi-stop-circle"></i> Ouça a carta
      </button>
      <button v-else class="button-audio" @click="audioCarta1Play()">
        <i class="bi bi-play-circle"></i> Ouça a carta
      </button>

      “Oi minha rainha, espero que esteja tudo bem com você e as crianças. Eu
      vou indo. Isolado do mundo. Sem saber o que está acontecendo. Os dias que
      não passam são os piores dias da minha vida. Ninguém está preparado para
      passar essa que estamos passando. Nenhum ser humano se importa com nós”,
      descreve uma das cartas.”
      <br />
      <br />
      <button
        v-if="audioCarta2Playing"
        class="button-audio"
        @click="audioCarta2Stop()"
      >
        <i class="bi bi-stop-circle"></i> Ouça a carta
      </button>
      <button v-else class="button-audio" @click="audioCarta2Play()">
        <i class="bi bi-play-circle"></i> Ouça a carta
      </button>
      “Bom, meu amor, eu não queria entrar nesse assunto. Mas não consigo
      esconder nada para você e até mesmo para não te preocupar. Mas tenho
      compromisso com a verdade. Vida, em 2011 eu tive um problema de saúde,
      tive tuberculose e água no pulmão. Passei pelos tratamentos necessários e
      superei a tuberculose. Só que de uns dias para cá estou sentindo muita dor
      no pulmão. Essa noite mesmo quase não dormi com dor. Quando amanheceu,
      tomei um remédio e deu uma amenizada. Hoje tentei ir para a enfermaria só
      que não consegui, tinha muito atendimento. Não quero que fique preocupada,
      vou fazer de tudo aqui para ver isso e ver o porquê está vindo essa dor.
      Não fala nada pra minha mãe pra não preocupar ela, tá minha vida.”
      <br />
      <br />

      <button
        v-if="audioCarta5Playing"
        class="button-audio"
        @click="audioCarta5Stop()"
      >
        <i class="bi bi-stop-circle"></i> Ouça a carta
      </button>
      <button v-else class="button-audio" @click="audioCarta5Play()">
        <i class="bi bi-play-circle"></i> Ouça a carta
      </button>

      “Tem mais uns cinco ou seis amigos na cela que estão [se sentindo] ruim
      também, fora uns 30 no raio que estão mals também. Então, pede pra minha
      mãe e pra meu pai fazerem uma corrente de oração bem forte, pois o negócio
      está sério. Olha, amor, é como tu diz, são poucos meses que faltam, porém
      que nos deixam muito distantes um do outro pelo fato de não podermos nos
      ver, nos abraçar, nos tocar e nos amar. Mas tenho muita fé em Deus que
      mais essa barra que estamos enfrentando será para honra e glória do nome
      Dele, eu não estou com medo de pegar esse vírus pois sei que Deus não iria
      me curar milagrosamente de uma úlcera pra me deixar falecer com esse
      vírus”
      <br />
      <br />
      <button
        v-if="audioCarta4Playing"
        class="button-audio"
        @click="audioCarta4Stop()"
      >
        <i class="bi bi-stop-circle"></i> Ouça a carta
      </button>
      <button v-else class="button-audio" @click="audioCarta4Play()">
        <i class="bi bi-play-circle"></i> Ouça a carta
      </button>

      “Oi meu grande e maravilhoso, mais precioso amor. Como está sua saúde? E
      seu psicológico, está melhor? Amor, é só Deus na nossa causa pois está um
      comentário que foram afastados 2 agentes por causa desse vírus e tem um
      monte de parceiros com sintomas. Porém, a enfermaria não suporta o tanto
      de pessoas que estão subindo com sintomas. Então, nem todos que estão com
      sintomas estão isolados. O barato tá louco, amor. Nós estamos sem saber o
      que fazer.”
    </p>
    <a
      class="link-fonte"
      href="https://www.geledes.org.br/apavorado-com-o-risco-da-covid-presos-enviam-cartas-de-amor-e-despedida/"
      target="_blank"
      ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
    >
  </div>
</template>

<script>
import audios from "@/mixins/audios.js";
export default {
  mixins: [audios],
  computed: {
    soundState() {
      return this.$store.state.soundState;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}
.text-orange {
  margin-top: 60px;
  background-color: #dc793a;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}
</style>